export default {
    edit: 'Edytuj',
    location: 'Lokalizacja + Regulamin',
    filter: 'Filtruj',
};
